import { CSSProperties } from "react";
import { IconStorage } from "@app/shared/icons/interfaces";
import { getStyle } from "@app/shared/icons/utils";

export const dragAndDropTexture: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <g style={getStyle(color, pathStyle)}>
      <circle cx="8" cy="4" r="2.5" />
      <circle cx="8" cy="12" r="2.5" />
      <circle cx="8" cy="20" r="2.5" />
      <circle cx="16" cy="4" r="2.5" />
      <circle cx="16" cy="12" r="2.5" />
      <circle cx="16" cy="20" r="2.5" />
    </g>
  ),
};